import React from "react";
import "./AnalyticsOverviewCard.css";
import BasicAreaChart from "../../UI-Controls/Charts/AreaChart/BasicAreaChart";
import ColumnChart from "../../UI-Controls/Charts/ColumnChart/GColumnChart";
import ShimmerLoader from "../../UI-Controls/Loader/ShimmerLoader";

const RightRow02Left = ({ SalesData, OrderData, loading,filtersApplied }) => {

  return (
    <div className="ParentLayout-RightRow02-Left">
      <div className="Sales-Analytics-Charts">
        <span className="Chart-Heading">Sales Analytics</span>
        <span className="Chart-SubHeading">{filtersApplied? "" : "Last 30 Days"}</span>
        {loading ? (
          <ShimmerLoader width="100%" height="250px" borderRadius="5px" />
        ) : (
          <BasicAreaChart
            data={SalesData}
            chartTitle=""
            chartSubtitle=""
            yAxisPosition="left"
            strokeType="smooth"
            chartWidth="100%"
            xAxisLabelSpacing={10}
            yAxisLabelSpacing={-10}
            legendSpacing={10}
            xAxisTickAmount={12}
          />
        )}
      </div>

      <hr className="chart-separator" />

      <div className="Sales-Analytics-Charts">
        <span className="Chart-Heading">Orders Analytics</span>
        <span className="Chart-SubHeading">{filtersApplied? "" : "Last 30 Days"}</span>
        {loading ? (
          <ShimmerLoader width="100%" height="250px" borderRadius="5px" />
        ) : (
          <ColumnChart data={OrderData} />
        )}
      </div>
    </div>
  );
};

export default RightRow02Left;